/** Ссылки на страницы приложения в сторах. */
export const STORE_LINKS = {
  apple: 'https://apps.apple.com/app/liga-team/id6450848405',
  google: 'https://play.google.com/store/apps/details?id=com.growapp.ligaapp',
  huawei: 'https://appgallery.huawei.com/#/app/C107741263',
} as const;

export const UPDATE_PROMPT_DISMISSED_KEY = 'update_prompt_dismissed_version';
